/**CORE LIBRARIES IMPORT */
import React from "react";



const DemocraticEducation=()=>{
    return(
        <>
     

       
        </>
    )
}

export default DemocraticEducation;